import React, { useState } from "react";
import styled from "styled-components";
import { COLORS } from "../../../../COLORS";
import { useNavigate } from "react-router-dom";
import FormParticular from "./FormParticular";
import Formules from "../../../Utils/Formules";
import FormBusinessPro from "./FormsBusinessPro/FormBusinessPro";
import FormBusinessFree from "./FormBusinessFree";
const FormBusiness = () => {
  const [optionChoose, setOptionChoose] = useState("");
  const [seeOffre, setSeeOffre] = useState(false);
  const nav = useNavigate();
  const chooseForm = () => {
    switch (optionChoose) {
      case "Particulier":
        return <FormParticular />;
      case "Pro":
        return <FormBusinessFree />;
      // return <FormBusinessPro />;

      default:
        break;
    }
  };
  return (
    <StyledFormBusiness>
      <button className="btn-back-publish-classi" onClick={() => nav("/post")}>
        {"<< Retour"}
      </button>
      {/* <button
        className="btn-see-offre"
        onClick={() => setSeeOffre((prev) => !prev)}
      >
        🚀{seeOffre && "NE PLUS "}VOIR LES OFFRES
      </button> */}
      {seeOffre && <Formules />}
      <div className="box-parent">
        <h2>Votre business</h2>
        {optionChoose && (
          <span
            className="statut-publication"
            onClick={() => setOptionChoose("")}
          >
            Statut : {optionChoose}
          </span>
        )}
        {!optionChoose && (
          <div className="statut-business">
            <button onClick={() => setOptionChoose("Particulier")}>
              Particulier
            </button>
            {/* <button onClick={() => setOptionChoose("Pro")}>Entreprise</button> */}
            <button onClick={() => setOptionChoose("Pro")}>Entreprise</button>
          </div>
        )}
        {chooseForm()}
      </div>
    </StyledFormBusiness>
  );
};

export default FormBusiness;

const StyledFormBusiness = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  .btn-back-publish-classi {
    color: white;
    display: flex;
    align-items: center;
    background: ${COLORS.green};
    margin-bottom: 15px;
    padding: 10px 25px;
    border: none;
    outline: none;
    cursor: pointer;
    border-radius: 5px;
    box-shadow: 0px 2px 5px rgba(255, 255, 255, 0.4);
    transition: 0.3s;
    font-size: 1.1em;
  }
  .btn-back-publish-classi:hover {
    background: ${COLORS.footer};
    border: solid 2px ${COLORS.green};
  }
  .btn-see-offre {
    background: ${COLORS.orange_new};
    padding: 5px 20px;
    border: none;
    outline: none;
    color: white;
    font-size: 1.3em;
    text-align: center;
    margin-bottom: 20px;
    border-radius: 5px;
    box-shadow: 0px 2px 5px ${COLORS.orange_new};
    transition: 0.3s;
    cursor: pointer;
  }
  .btn-see-offre:hover {
    border: solid 2px ${COLORS.orange_new};
    background: ${COLORS.footer};
    transform: scale(1.1);
  }
  .box-parent {
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    h2 {
      text-align: center;
      color: ${COLORS.border_and_text_blue};
      font-size: 2.9em;
    }
    .span-info {
      display: block;
      margin-top: 20px;
    }
    border-radius: 20px;
    padding: 20px;
    width: 100%;
    /* border: solid 2px ${COLORS.border_and_text_blue}; */
    .statut-publication {
      transition: 0.3s;
      text-align: center;
      cursor: pointer;
      color: ${COLORS.orange_new};
      filter: drop-shadow(2px 1px 2px ${COLORS.green});
      margin-bottom: 10px;
      display: block;
    }
    span {
      font-size: 0.8em;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
        Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
        sans-serif;
      color: white;
    }
    .statut-business {
      padding: 5px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin: 5px 0px;
      button {
        padding: 10px 25px;
        border: none;
        outline: none;
        border-radius: 20px;
        margin: 10px;
        letter-spacing: 0.1em;
        cursor: pointer;
        transition: 0.3s;
        background: ${COLORS.footer};
        border: solid 2px ${COLORS.border_and_text_blue};
        color: ${COLORS.border_and_text_blue};
        font-size: 1.8em;
      }
      button:hover {
        background: ${COLORS.main};
        border: solid 1px ${COLORS.green};
        color: ${COLORS.green};
      }
    }
  }
  @media screen and (max-width: 445px) {
    padding: 5px;
    .box-parent {
      h2 {
        font-size: 2.5em;
      }
      width: 100%;
    }
  }
`;
